import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { NotificationService } from '../../toaster/notification.service';

@Injectable({
  providedIn: 'root'
})
export class ChildRouterGuard implements  CanActivateChild {
  response: any;
  constructor(private httpAuth: AuthService,
              private notifyService: NotificationService) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const authenticated = this.httpAuth.routeCheck(state.url);
      const subject = new Subject<boolean>();
      authenticated.subscribe(res => {
        this.response = res;
        subject.next(this.response.status);
        console.log(this.response.status);
        if (!this.response.status) {
          this.notifyService.showError(this.response.msg, 'Error!');
        }
      });
      return subject.asObservable();
  }
}
